import actionTypes from '../constants/action-types';

const lastAppliedMigrationId = (state = null, action) => {
  if (action.type !== actionTypes.SET_LAST_APPLIED_MIGRATION_ID) return state;

  return action.payload.lastAppliedMigrationId;
};

export default lastAppliedMigrationId;
